import axiosAuthRequired from "./axiosAuthRequired"
import qs from "qs"
import axios from "@/api/axiosAuthRequired.js"
import { isEmpty } from "lodash"

const PROGUIDES_WEB_URL = process.env.PROGUIDES_WEB_URL
const baseUrl = `${PROGUIDES_WEB_URL}api/v2/`

const getAuthHeaders = () => {
  let headers = {}
  let clientCredentials = window.localStorage.getItem("client_credentials")
  if (clientCredentials) {
    headers["Authorization"] = "Bearer " + clientCredentials
  }

  return headers
}

export const setUserGameStatus = async body => {
  try {
    const clientCredentials = localStorage.getItem("client_credentials")
    const config = {
      headers: {
        Authorization: "Bearer " + clientCredentials,
      },
    }
    const url = `${PROGUIDES_WEB_URL}api/v2/user/account/games/set_user_game_status`
    const res = await axios.post(url, body, config)
    return res.data
  } catch (error) {
    console.error(error)
    return null
  }
}

export const fetchUser = () => {
  let url = process.env.PROGUIDES_WEB_URL + "api/v2/user/account"
  return axiosAuthRequired({
    method: "get",
    url: url,
    headers: getAuthHeaders(),
  })
    .then(response => {
      return response.data
    })
    .catch(error => {
      return Promise.reject(error)
    })
}

export const fetchUserSettings = () => {
  let url = process.env.PROGUIDES_WEB_URL + "api/v2/user/profile/settings"
  return axiosAuthRequired({
    method: "get",
    url: url,
    headers: getAuthHeaders(),
  })
    .then(response => {
      return response.data
    })
    .catch(error => {
      return Promise.reject(error)
    })
}

export const fetchUserCapabilities = () => {
  let url = process.env.PROGUIDES_WEB_URL + "api/v2/user/capabilities"
  return axiosAuthRequired({
    method: "get",
    url: url,
    headers: getAuthHeaders(),
  })
    .then(response => {
      return response.data
    })
    .catch(error => {
      return Promise.reject(error)
    })
}

export const getUserActiveGames = () => {
  const authHeaders = getAuthHeaders()
  if (isEmpty(authHeaders)) {
    return null
  }

  return axiosAuthRequired({
    method: "get",
    url:
      process.env.PROGUIDES_WEB_URL +
      "api/v2/user/account/games/get_user_games_status",
    headers: authHeaders,
  })
    .then(response => {
      return response.data
    })
    .catch(error => {
      return Promise.reject(error)
    })
}

export const setUserActiveGame = game => {
  let body = new FormData()
  body.append("game", game)
  body.append("active", 1)

  return axiosAuthRequired({
    method: "post",
    url:
      process.env.PROGUIDES_WEB_URL +
      "api/v2/user/account/games/set_user_game_status",
    headers: getAuthHeaders(),
    data: body,
  })
    .then(response => {
      return response.data
    })
    .catch(error => {
      return Promise.reject(error)
    })
}

export const updateUserUsername = username => {
  return axiosAuthRequired({
    method: "put",
    url:
      process.env.PROGUIDES_WEB_URL + "api/v2/user/account/settings/username",
    headers: { "Content-Type": "application/form-data", ...getAuthHeaders() },
    data: qs.stringify({ username }),
  })
    .then(response => {
      return response.data
    })
    .catch(error => {
      return Promise.reject(error)
    })
}

export const updateUserEmail = ({ currentPassword, email }) => {
  return axiosAuthRequired({
    method: "put",
    url: process.env.PROGUIDES_WEB_URL + "api/v2/user/account/settings/email",
    headers: getAuthHeaders(),
    data: qs.stringify({ email, current_password: currentPassword }),
  })
    .then(response => {
      return response.data
    })
    .catch(error => {
      return Promise.reject(error)
    })
}

export const updateUserPassword = ({
  currentPassword,
  newPassword,
  confirmPassword,
}) => {
  return axiosAuthRequired({
    method: "put",
    url:
      process.env.PROGUIDES_WEB_URL + "api/v2/user/account/settings/password",
    headers: getAuthHeaders(),
    data: qs.stringify({
      current_password: currentPassword,
      new_password: newPassword,
      confirm_password: confirmPassword,
    }),
  })
    .then(response => {
      return response.data
    })
    .catch(error => {
      return Promise.reject(error)
    })
}

export const updateUserAvatar = avatar => {
  return axiosAuthRequired({
    method: "put",
    url: process.env.PROGUIDES_WEB_URL + "api/v2/user/profile/settings",
    headers: getAuthHeaders(),
    data: qs.stringify({ avatar: JSON.stringify(avatar) }),
  })
    .then(response => {
      return response.data
    })
    .catch(error => {
      return Promise.reject(error)
    })
}

export const updateUserDetails = ({ username, avatar, timezone }) => {
  const formData = Object.fromEntries(Object.entries({
    username,
    avatar_id: avatar ? JSON.stringify(avatar.id) : null,
    timezone: timezone,
  }).filter(([_, v]) => v != null))
  return axiosAuthRequired({
    method: "put",
    url:
      process.env.PROGUIDES_WEB_URL +
      "api/v2/user/account/settings/user-details",
    headers: getAuthHeaders(),
    data: qs.stringify(formData),
  })
    .then(response => {
      return response.data
    })
    .catch(error => {
      return Promise.reject(error)
    })
}

export const getUserPGPoints = () => {
  return axiosAuthRequired({
    method: "GET",
    url: process.env.PROGUIDES_WEB_URL + "api/v2/user/resources/pg-points",
    headers: getAuthHeaders(),
  })
    .then(response => {
      return response.data
    })
    .catch(error => {
      return Promise.reject(error)
    })
}

export const getUserLeagueOfLegendsInfo = () => {
  return axiosAuthRequired({
    method: "get",
    url:
      process.env.PROGUIDES_WEB_URL +
      "api/v2/user/account/games/leagueoflegends",
    headers: getAuthHeaders(),
  })
    .then(response => {
      return response.data
    })
    .catch(error => {
      return Promise.reject(error)
    })
}

export const updateUserLeagueOfLegendsInfo = ({
  summonerName,
  summonerServer,
  favoriteChampionIds,
  favoriteRoles,
}) => {
  return axiosAuthRequired({
    method: "put",
    url:
      process.env.PROGUIDES_WEB_URL +
      "api/v2/user/account/games/leagueoflegends",
    headers: getAuthHeaders(),
    data: qs.stringify({
      summoner_name: summonerName,
      summoner_server: summonerServer,
      favorite_champion_ids: favoriteChampionIds,
      favorite_roles: favoriteRoles,
    }),
  })
    .then(response => {
      return response.data
    })
    .catch(error => {
      return Promise.reject(error)
    })
}

export const getUserFortniteInfo = () => {
  return axiosAuthRequired({
    method: "get",
    url: process.env.PROGUIDES_WEB_URL + "api/v2/user/account/games/fortnite",
    headers: getAuthHeaders(),
  })
    .then(response => {
      return response.data
    })
    .catch(error => {
      return Promise.reject(error)
    })
}

export const updateUserFortniteInfo = ({ epicUsername }) => {
  return axiosAuthRequired({
    method: "put",
    url: process.env.PROGUIDES_WEB_URL + "api/v2/user/account/games/fortnite",
    headers: getAuthHeaders(),
    data: qs.stringify({
      epic_username: epicUsername,
    }),
  })
    .then(response => {
      return response.data
    })
    .catch(error => {
      return Promise.reject(error)
    })
}

export const getUserHearthstoneInfo = () => {
  return axiosAuthRequired({
    method: "get",
    url:
      process.env.PROGUIDES_WEB_URL + "api/v2/user/account/games/hearthstone",
    headers: getAuthHeaders(),
  })
    .then(response => {
      return response.data
    })
    .catch(error => {
      return Promise.reject(error)
    })
}

export const updateUserHearthstoneInfo = ({
  hearthstoneRank,
  preferredArchetype,
}) => {
  return axiosAuthRequired({
    method: "put",
    url:
      process.env.PROGUIDES_WEB_URL + "api/v2/user/account/games/hearthstone",
    headers: getAuthHeaders(),
    data: qs.stringify({
      hearthstone_rank: hearthstoneRank,
      preferred_archetype: preferredArchetype,
    }),
  })
    .then(response => {
      return response.data
    })
    .catch(error => {
      return Promise.reject(error)
    })
}

export const getUserCSGOInfo = () => {
  return axiosAuthRequired({
    method: "get",
    url: process.env.PROGUIDES_WEB_URL + "api/v2/user/account/games/csgo",
    headers: getAuthHeaders(),
  })
    .then(response => {
      return response.data
    })
    .catch(error => {
      return Promise.reject(error)
    })
}

export const updateUserCSGOInfo = ({ csgoRank }) => {
  return axiosAuthRequired({
    method: "put",
    url: process.env.PROGUIDES_WEB_URL + "api/v2/user/account/games/csgo",
    headers: getAuthHeaders(),
    data: qs.stringify({
      csgo_rank: csgoRank,
    }),
  })
    .then(response => {
      return response.data
    })
    .catch(error => {
      return Promise.reject(error)
    })
}

export const syncUserChatAvatarAndName = async instaProToken => {
  try {
    await axiosAuthRequired({
      method: "post",
      url: process.env.PROGUIDES_WEB_URL + "api/v2/user/update-chat-display",
      headers: {
        ...getAuthHeaders(),
        "X-INSTA-TOKEN": instaProToken,
      },
    })
  } catch (e) {
    console.error("Failed to sync user chat username and avatar: ", e)
  }
}

export const checkFeatureReleaseNotification = async feature => {
  try {
    const url = `${process.env.PROGUIDES_WEB_URL}api/v2/user/notifications/check-feature-release-notification?feature=${feature}`
    const res = await axios.get(url, {
      headers: getAuthHeaders(),
    })
    return res.data
  } catch (error) {
    console.error(error)
    return null
  }
}

export const ackFeatureReleaseNotification = async feature => {
  try {
    const url = `${process.env.PROGUIDES_WEB_URL}api/v2/user/notifications/ack-feature-release-notification`
    await axios.post(
      url,
      {
        feature,
      },
      {
        headers: getAuthHeaders(),
      }
    )
  } catch (error) {
    console.error(error)
  }
}

export const getOnboardingStatus = async () => {
  try {
    const url = `${process.env.PROGUIDES_WEB_URL}api/v2/user/onboarding/check-onboarding-step-status`
    const res = await axios.get(url, { headers: getAuthHeaders() })
    return res.data
  } catch (error) {
    console.error(error)
    return {}
  }
}

export const completeOnboarding = async () => {
  try {
    const url = `${process.env.PROGUIDES_WEB_URL}api/v2/user/onboarding/complete-onboarding-step`
    await axios.post(url, {}, { headers: getAuthHeaders() })
  } catch (error) {
    console.error(error)
  }
}

export const getUserNameShouldBeUpdated = async () => {
  try {
    const url = `${process.env.PROGUIDES_WEB_URL}api/v2/user/account/should-update-name`
    const { data } = await axios.get(url, {
      headers: getAuthHeaders(),
    })
    return data
  } catch (error) {
    console.error(error)
  }
}

export const getUserReferralCode = async () => {
  try {
    const config = {
      headers: getAuthHeaders(),
    }
    const url = `${baseUrl}user/referrals/assign`
    const res = await axios.post(url, null, config)
    return res.data
  } catch (error) {
    console.error(error)
    return null
  }
}

export const sendUserInvite = async email => {
  try {
    const config = {
      headers: getAuthHeaders(),
    }
    const body = {
      email,
    }
    const url = `${baseUrl}user/referrals/send-invite`
    const res = await axios.post(url, body, config)
    return res.data
  } catch (error) {
    console.error(error)
    return error.response.data
  }
}

export const updateSubscriptions = async (
  paymentType,
  subscriptionId,
  action,
  questionnaireAnswers
) => {
  try {
    const url = `${PROGUIDES_WEB_URL}payment/${paymentType}/functions/manage_subscription.php`
    const body = new FormData()
    body.append("subscription_id", subscriptionId)
    body.append("action", action)
    if (questionnaireAnswers) {
      body.append("questionnaire_answers", JSON.stringify(questionnaireAnswers))
    }
    const config = {
      headers: getAuthHeaders(),
    }
    const res = await axios.post(url, body, config)
    return res.data
  } catch (error) {
    console.error(error)
    return error.response
  }
}

export const fetchSubscriptionCancelQuestionnaire = async () => {
  try {
    const url = `${baseUrl}user-feedback/questionnaires/subscription-cancellation`
    const config = {
      headers: getAuthHeaders(),
    }
    const res = await axios.get(url, config)
    return res.data
  } catch (error) {
    console.error(error)
    return error.response
  }
}

export const getUserOptimizelyId = async () => {
  try {
    const url = `${PROGUIDES_WEB_URL}functions/user/get-optimizely-user-id`
    const res = await axios.get(url)
    return res.data
  } catch (error) {
    console.error(error)
    return error.response
  }
}

export const getOptimizelyForcedVariation = async ({
  feature,
  optimizelyId,
}) => {
  try {
    const url = `${baseUrl}services/optimizely/forced-variation`
    const config = {
      params: {
        feature_key: feature,
        user_id: optimizelyId,
      },
    }
    const res = await axios.get(url, config)
    return res.data
  } catch (error) {
    console.error(error)
    return error.response
  }
}



// WEBPACK FOOTER //
// ./src/api/user.js